(function () {
  'use strict';

  var productDataCache = {};
  var siblingSearchCache = {};
  var observerInstance = null;
  var DEBUG = false;

  function log() {
    if (DEBUG) {
      console.log.apply(console, arguments);
    }
  }

  // ── Diccionario de colores comunes (español + inglés) ──
  var colorMap = {
    marino: '#0e1f3d', navy: '#0e1f3d',
    azul: '#2196F3', blue: '#2196F3',
    celeste: '#a8def0', duck: '#00838f',
    terracota: '#d84315', mustard: '#f9a825',
    mostaza: '#f9a825', negro: '#000000',
    black: '#000000', blanco: '#ffffff',
    white: '#ffffff', gris: '#757575',
    grey: '#757575', antracita: '#37474f',
    rojo: '#c62828', red: '#c62828',
    rosa: '#ff80ab', pink: '#ff80ab',
    burdeos: '#800020', granate: '#800020',
    marron: '#5d4037', 'marrón': '#5d4037',
    brown: '#5d4037', verde: '#2e7d32',
    green: '#2e7d32', oliva: '#556b2f',
    crema: '#f5f5dc', beige: '#f5f5dc',
    arena: '#e8d8c8', camel: '#c19a6b',
    kaki: '#8f9779', khaki: '#8f9779',
    caqui: '#8f9779', amarillo: '#f9a825',
    yellow: '#f9a825', naranja: '#ff6d00',
    orange: '#ff6d00', coral: '#ff7043',
    turquesa: '#00bcd4', lavanda: '#b39ddb',
    lila: '#ce93d8', taupe: '#8d6e63',
    kashmir: '#d4c5a9', 'azulón': '#1565c0',
    azulon: '#1565c0'
  };

  // ── Detectar opciones de Color / Talla ──
  var colorNames = ['color', 'colour', 'colore', 'farbe', 'couleur'];
  var sizeNames  = ['size', 'talla', 'taille', 'größe', 'tamaño'];

  function isColorOpt(name) {
    var n = name.toLowerCase();
    return colorNames.some(function (c) { return n.indexOf(c) !== -1; });
  }
  function isSizeOpt(name) {
    var n = name.toLowerCase();
    return sizeNames.some(function (s) { return n.indexOf(s) !== -1; });
  }

  // ── Obtener hex del color ──
  function colorHex(name) {
    var key = name.toLowerCase().trim();
    return colorMap[key] || key;  // fallback al nombre CSS
  }

  // Helper para construir URLs de imágenes con query parameters correctos
  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  // ── Selectores de imagen del tema Kalles ──
  var IMG_SEL = [
    '.t4s-pr-slide.is-active img',
    'img.t4s-pr-slide-img',
    '.t4s-product-inner img',
    '.t4s-widget_img_pr img',
    '[data-master] img'
  ].join(', ');

  // ── Cargar datos del producto (con caché) ──
  function loadProduct(handle, card) {
    if (productDataCache[handle]) {
      return Promise.resolve(productDataCache[handle]);
    }

    // Intentar leer el JSON embebido en la tarjeta
    var scriptEl = card ? card.querySelector('.auto-sibling-product-json') : null;
    if (scriptEl) {
      try {
        var product = JSON.parse(scriptEl.textContent);
        if (product && product.handle === handle) {
          log('[auto-siblings] Cargado instantáneamente desde el HTML para:', handle);
          productDataCache[handle] = product;
          return Promise.resolve(product);
        }
      } catch (e) {
        console.warn('[auto-siblings] Error al parsear JSON embebido:', e);
      }
    }

    log('[auto-siblings] Cargando desde la red (fetch) para:', handle);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        productDataCache[handle] = product;
        return product;
      });
  }

  function loadAndRenderForCard(card, container, handle) {
    if (card.getAttribute('data-sizes-loaded') === 'true' || card.classList.contains('is-loading-sizes')) {
      return;
    }

    card.classList.add('is-loading-sizes');

    // Cargar JSON del producto para decidir la estrategia
    loadProduct(handle, card).then(function (product) {
      var colorIdx = -1;
      for (var i = 0; i < product.options.length; i++) {
        if (isColorOpt(product.options[i].name)) { colorIdx = i; break; }
      }

      if (colorIdx !== -1 && product.options[colorIdx].values.length > 1) {
        // ─── CASO A: Colores como variantes internas ───
        renderInternalSwatches(card, container, product, colorIdx);
        card.classList.remove('is-loading-sizes');
        card.setAttribute('data-sizes-loaded', 'true');
      } else {
        // ─── CASO B: Buscar productos hermanos separados ───
        var baseTitle = container.getAttribute('data-base-title');
        searchAndRenderSiblings(card, container, baseTitle, handle, function() {
          card.classList.remove('is-loading-sizes');
          card.setAttribute('data-sizes-loaded', 'true');
        });
      }
    }).catch(function (err) {
      card.classList.remove('is-loading-sizes');
      log('[auto-siblings] Error cargando producto:', handle, err);
    });
  }

  // ── PUNTO DE ENTRADA: Inicializar todos los swatches nuevos ──
  function initializeSwatches() {
    var containers = document.querySelectorAll(
      '.auto-sibling-swatches:not([data-sibling-inited])'
    );
    if (!containers.length) return;

    var isMobile = !window.matchMedia('(hover: hover)').matches;

    containers.forEach(function (container) {
      container.setAttribute('data-sibling-inited', 'true');

      var handle = container.getAttribute('data-current-handle');
      var card = container.closest('.t4s-product');
      if (!card || !handle) return;

      // Cargar de inmediato para móviles para que estén listas al tacto
      if (isMobile) {
        loadAndRenderForCard(card, container, handle);
      }

      var inner = card.querySelector('.t4s-product-inner, .t4s-widget_img_pr') || card;
      var link = card.querySelector('.t4s-pr-slider-link, .t4s-product-inner a');

      // 1. Cargar al pasar el ratón (Escritorio / Laptop con ratón)
      if (inner) {
        inner.addEventListener('mouseenter', function onHover() {
          loadAndRenderForCard(card, container, handle);
        });
      }

      // 2. Interceptar toque en móvil
      if (link && inner) {
        link.addEventListener('click', function (e) {
          // Si el navegador soporta hover activo (está usando ratón), no bloquear el click
          if (window.matchMedia('(hover: hover)').matches) {
            return;
          }
          if (!inner.classList.contains('is-touched')) {
            e.preventDefault();
            e.stopPropagation();

            // Forzar carga por si acaso
            loadAndRenderForCard(card, container, handle);

            // Quitar la clase de otras tarjetas
            document.querySelectorAll('.t4s-product-inner.is-touched').forEach(function (el) {
              el.classList.remove('is-touched');
            });

            inner.classList.add('is-touched');
          }
        });
      }
    });
  }

  // Cerrar el selector de tallas en móvil al hacer click/toque fuera
  document.addEventListener('touchstart', function (e) {
    if (!e.target.closest('.t4s-product-inner')) {
      document.querySelectorAll('.t4s-product-inner.is-touched').forEach(function (el) {
        el.classList.remove('is-touched');
      });
    }
  }, { passive: true });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.t4s-product-inner')) {
      document.querySelectorAll('.t4s-product-inner.is-touched').forEach(function (el) {
        el.classList.remove('is-touched');
      });
    }
  });

  // Habilitar carga dinámica inmediata al pasar ratón o dedo por encima de la tarjeta
  document.addEventListener('mouseover', function (e) {
    var card = e.target.closest('.t4s-product');
    if (card) {
      var container = card.querySelector('.auto-sibling-swatches');
      var handle = container ? container.getAttribute('data-current-handle') : null;
      if (container && handle) {
        loadAndRenderForCard(card, container, handle);
      }
    }
  });

  document.addEventListener('touchstart', function (e) {
    var card = e.target.closest('.t4s-product');
    if (card) {
      var container = card.querySelector('.auto-sibling-swatches');
      var handle = container ? container.getAttribute('data-current-handle') : null;
      if (container && handle) {
        loadAndRenderForCard(card, container, handle);
      }
    }
  }, { passive: true });

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  //  CASO A: Variantes de color internas (ej: Bermuda Jogger)
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  function renderInternalSwatches(card, container, product, colorIdx) {
    var colorValues = product.options[colorIdx].values;
    var sizeIdx = -1;
    for (var i = 0; i < product.options.length; i++) {
      if (isSizeOpt(product.options[i].name)) { sizeIdx = i; break; }
    }

    // Generar círculos de color
    var html = '';
    colorValues.forEach(function (colorName, idx) {
      var hex = colorHex(colorName);
      var isActive = (colorName === activeColor) ? 'is-active' : '';

      // Buscar variante con imagen para este color
      var variantImg = null;
      for (var v = 0; v < product.variants.length; v++) {
        var variant = product.variants[v];
        if (variant.options[colorIdx] === colorName && variant.featured_image) {
          variantImg = variant.featured_image.src;
          break;
        }
      }

      html += '<span class="auto-swatch-dot ' + isActive + '" ' +
              'data-color-value="' + colorName + '" ' +
              'data-image="' + (variantImg || '') + '" ' +
              'style="background-color: ' + hex + ';" ' +
              'title="' + colorName + '"></span>';
    });

    container.innerHTML = html;

    // Mostrar tallas del color de la variante activa de la tarjeta
    var activeColor = colorValues[0];
    try {
      var currentColor = container.getAttribute('data-current-color');

      // Intentar extraer el color del título de la tarjeta en el DOM (modificado por apps como Varia)
      var titleEl = card.querySelector('.t4s-product-title a, .t4s-product-title, .t4s-widget__pr-title');
      if (titleEl) {
        var text = titleEl.textContent.trim();
        var match = text.split(/\s+[-–/]\s+/);
        if (match.length > 1) {
          currentColor = match.slice(1).join(' - ').trim();
        }
      }

      if (currentColor) {
        var normalizedCurrent = currentColor.toLowerCase().trim();
        for (var c = 0; c < colorValues.length; c++) {
          if (colorValues[c].toLowerCase().trim() === normalizedCurrent) {
            activeColor = colorValues[c];
            break;
          }
        }
      } else {
        var optionsAttr = card.getAttribute('data-product-options');
        if (optionsAttr) {
          var optionsObj = JSON.parse(optionsAttr);
          var variantId = optionsObj.VariantFirstID;
          if (variantId) {
            for (var v = 0; v < product.variants.length; v++) {
              if (product.variants[v].id === parseInt(variantId)) {
                activeColor = product.variants[v].options[colorIdx];
                break;
              }
            }
          }
        }
      }
    } catch (e) {
      console.warn('[auto-siblings] Error al obtener color activo:', e);
    }
    renderInternalSizes(card, product, activeColor, colorIdx, sizeIdx);

    // Eventos
    var dots = container.querySelectorAll('.auto-swatch-dot');
    dots.forEach(function (dot) {

      dot.addEventListener('mouseenter', function () {
        var img = dot.getAttribute('data-image');
        if (!img) return;
        var mainImg = card.querySelector(IMG_SEL);
        if (mainImg) {
          if (!mainImg.getAttribute('data-orig-src')) {
            mainImg.setAttribute('data-orig-src', mainImg.src || '');
          }
          mainImg.src = imgUrl(img, 900);
          mainImg.srcset = imgUrl(img, 900) + ' 900w';
        }
      });

      dot.addEventListener('mouseleave', function () {
        if (dot.classList.contains('is-active')) return;
        var activeDot = container.querySelector('.auto-swatch-dot.is-active');
        if (!activeDot) return;
        var activeImg = activeDot.getAttribute('data-image');
        var mainImg = card.querySelector(IMG_SEL);
        if (mainImg && activeImg) {
          mainImg.src = imgUrl(activeImg, 900);
          mainImg.srcset = imgUrl(activeImg, 900) + ' 900w';
        }
      });

      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        dots.forEach(function (d) { d.classList.remove('is-active'); });
        dot.classList.add('is-active');

        var colorValue = dot.getAttribute('data-color-value');
        var img = dot.getAttribute('data-image');

        // Actualizar imagen
        var mainImg = card.querySelector(IMG_SEL);
        if (mainImg && img) {
          mainImg.src = imgUrl(img, 900);
          mainImg.srcset = imgUrl(img, 900) + ' 900w';
        }

        // Actualizar tallas para el nuevo color
        renderInternalSizes(card, product, colorValue, colorIdx, sizeIdx);
      });
    });
  }

  function renderInternalSizes(card, product, selectedColor, colorIdx, sizeIdx) {
    var sizeContainer = card.querySelector('.auto-sibling-sizes-overlay');
    if (!sizeContainer) return;

    if (sizeIdx === -1) {
      sizeContainer.innerHTML = '';
      sizeContainer.removeAttribute('data-loaded');
      return;
    }

    // Filtrar variantes de este color
    var colorVariants = product.variants.filter(function (v) {
      return v.options[colorIdx] === selectedColor;
    });

    var html = '<div class="auto-sizes-list">';
    var seenSizes = [];

    colorVariants.forEach(function (v) {
      var sizeValue = v.options[sizeIdx];
      if (seenSizes.indexOf(sizeValue) !== -1) return;
      
      // Si no hay stock de esta talla, no mostrarla en el overlay
      if (!v.available) return;

      seenSizes.push(sizeValue);

      html += '<button class="auto-size-btn" ' +
              'data-variant-id="' + v.id + '">' +
              sizeValue + '</button>';
    });

    if (seenSizes.length === 0) {
      sizeContainer.innerHTML = '';
      sizeContainer.removeAttribute('data-loaded');
      return;
    }

    html += '</div>';
    sizeContainer.innerHTML = html;
    sizeContainer.setAttribute('data-loaded', 'true');
    bindCartButtons(sizeContainer);
  }

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  //  CASO B: Productos hermanos separados (Nombre - COLOR)
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  function searchAndRenderSiblings(card, container, baseTitle, currentHandle, callback) {
    if (siblingSearchCache[baseTitle]) {
      doRenderSiblings(card, container, siblingSearchCache[baseTitle], currentHandle, callback);
      return;
    }

    var searchUrl = '/search/suggest.json?q=' +
      encodeURIComponent(baseTitle) +
      '&resources[type]=product&resources[limit]=10';

    fetch(searchUrl)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var results = (data.resources && data.resources.results &&
                       data.resources.results.products) || [];
        var siblings = results.filter(function (p) {
          return p.title.toLowerCase().indexOf(baseTitle.toLowerCase()) === 0;
        });
        siblingSearchCache[baseTitle] = siblings;
        doRenderSiblings(card, container, siblings, currentHandle, callback);
      })
      .catch(function (err) {
        console.warn('[auto-siblings] Error en búsqueda:', err);
        if (callback) callback();
      });
  }

  function doRenderSiblings(card, container, siblings, currentHandle, callback) {
    if (siblings.length === 0) {
      container.style.display = 'none';
      if (callback) callback();
      return;
    }

    var html = '';
    siblings.forEach(function (sibling) {
      var parts = sibling.title.split(' - ');
      var colorName = parts.length > 1 ? parts.slice(1).join(' - ').trim() : 'Color';
      var hex = colorHex(colorName);
      var isActive = sibling.handle === currentHandle ? 'is-active' : '';

      html += '<span class="auto-swatch-dot ' + isActive + '" ' +
              'data-handle="' + sibling.handle + '" ' +
              'data-image="' + sibling.image + '" ' +
              'data-url="' + sibling.url + '" ' +
              'data-color="' + colorName + '" ' +
              'style="background-color: ' + hex + ';" ' +
              'title="' + colorName + '"></span>';
    });

    container.innerHTML = html;

    // Cargar tallas del producto activo
    loadProduct(currentHandle, card).then(function (product) {
      var sizeIdx = -1;
      for (var i = 0; i < product.options.length; i++) {
        if (isSizeOpt(product.options[i].name)) { sizeIdx = i; break; }
      }
      if (sizeIdx !== -1) renderSiblingsSizes(card, product, sizeIdx);
      if (callback) callback();
    }).catch(function() {
      if (callback) callback();
    });

    // Eventos sobre los círculos hermanos
    var dots = container.querySelectorAll('.auto-swatch-dot');
    dots.forEach(function (dot) {

      dot.addEventListener('mouseenter', function () {
        var mainImg = card.querySelector(IMG_SEL);
        if (mainImg) {
          if (!mainImg.getAttribute('data-orig-src')) {
            mainImg.setAttribute('data-orig-src', mainImg.src || '');
          }
          var img = dot.getAttribute('data-image');
          mainImg.src = imgUrl(img, 900);
          mainImg.srcset = imgUrl(img, 900) + ' 900w';
        }
      });

      dot.addEventListener('mouseleave', function () {
        if (dot.classList.contains('is-active')) return;
        var activeDot = container.querySelector('.auto-swatch-dot.is-active');
        var mainImg = card.querySelector(IMG_SEL);
        if (mainImg && activeDot) {
          var aImg = activeDot.getAttribute('data-image');
          mainImg.src = imgUrl(aImg, 900);
          mainImg.srcset = imgUrl(aImg, 900) + ' 900w';
        }
      });

      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        dots.forEach(function (d) { d.classList.remove('is-active'); });
        dot.classList.add('is-active');

        var clickedHandle = dot.getAttribute('data-handle');
        var clickedUrl = dot.getAttribute('data-url');
        var clickedImage = dot.getAttribute('data-image');

        // Actualizar enlaces
        var titleLink = card.querySelector('.t4s-product-title a, .t4s-widget__pr-title');
        var imgLink = card.querySelector('.t4s-pr-slider-link, .t4s-widget_img_pr a');
        if (titleLink) titleLink.setAttribute('href', clickedUrl);
        if (imgLink) imgLink.setAttribute('href', clickedUrl);

        // Actualizar imagen
        var mainImg = card.querySelector(IMG_SEL);
        if (mainImg) {
          mainImg.src = imgUrl(clickedImage, 900);
          mainImg.srcset = imgUrl(clickedImage, 900) + ' 900w';
        }

        // Recargar tallas del nuevo handle
        loadProduct(clickedHandle, card).then(function (product) {
          var sizeIdx = -1;
          for (var i = 0; i < product.options.length; i++) {
            if (isSizeOpt(product.options[i].name)) { sizeIdx = i; break; }
          }
          if (sizeIdx !== -1) renderSiblingsSizes(card, product, sizeIdx);
        });
      });
    });
  }

  function renderSiblingsSizes(card, product, sizeIdx) {
    var sizeContainer = card.querySelector('.auto-sibling-sizes-overlay');
    if (!sizeContainer) return;

    var html = '<div class="auto-sizes-list">';
    var seenSizes = [];

    product.variants.forEach(function (v) {
      var sizeValue = v.options[sizeIdx];
      if (seenSizes.indexOf(sizeValue) !== -1) return;

      // Si no hay stock de esta talla, no mostrarla en el overlay
      if (!v.available) return;

      seenSizes.push(sizeValue);

      html += '<button class="auto-size-btn" ' +
              'data-variant-id="' + v.id + '">' +
              sizeValue + '</button>';
    });

    if (seenSizes.length === 0) {
      sizeContainer.innerHTML = '';
      sizeContainer.removeAttribute('data-loaded');
      return;
    }

    html += '</div>';
    sizeContainer.innerHTML = html;
    sizeContainer.setAttribute('data-loaded', 'true');
    bindCartButtons(sizeContainer);
  }

  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  //  Añadir al carrito + abrir drawer
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━

  // Actualiza el carrito y abre el drawer con el pipeline nativo de Kalles.
  // interactable.min.js se carga en diferido, así que si el módulo aún no
  // existe se reintenta durante ~5s antes de recurrir a la página del carrito.
  function nativeCartRefresh(attempt) {
    if (window.T4SThemeSP && T4SThemeSP.Cart && typeof T4SThemeSP.Cart.getToFetch === 'function') {
      T4SThemeSP.Cart.getToFetch(true);
      return;
    }
    if (attempt < 20) {
      setTimeout(function () { nativeCartRefresh(attempt + 1); }, 250);
    } else {
      window.location.href = (window.T4Sroutes && T4Sroutes.cart_url) || '/cart';
    }
  }

  function bindCartButtons(sizeContainer) {
    sizeContainer.querySelectorAll('.auto-size-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        btn.classList.add('is-loading');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId), quantity: 1 }]
          })
        })
        .then(function (r) {
          if (!r.ok) throw new Error('cart/add.js respondió ' + r.status);
          return r.json();
        })
        .then(function () {
          btn.classList.remove('is-loading');
          // Delegar en el pipeline nativo de Kalles: actualiza items, subtotal,
          // contadores y abre el drawer (afterActionATC). Un único escritor del
          // DOM del carrito evita las condiciones de carrera con el tema.
          nativeCartRefresh(0);
        })
        .catch(function (err) {
          console.error('[auto-siblings] Error al añadir al carrito:', err);
          btn.classList.remove('is-loading');
        });
      });
    });
  }



  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  //  Arranque + Observador de mutaciones (scroll infinito)
  //  NOTA: Se espera a que la app Varia termine de manipular el DOM
  // ━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━
  var _retryTimer = null;
  var _retryCount = 0;
  var MAX_RETRIES = 10;

  function scheduleInit() {
    clearTimeout(_retryTimer);
    _retryCount = 0;
    // Inicializar rápido tras 200ms y arrancar el observador
    _retryTimer = setTimeout(function () {
      initializeSwatches();
      startObserver();
    }, 200);
  }

  function retryInit() {
    // Re-inicializar swatches que Varia pudo haber destruido
    _retryCount++;
    if (_retryCount > MAX_RETRIES) {
      if (observerInstance) {
        observerInstance.disconnect();
      }
      return;
    }

    // Resetear flag de los contenedores para re-procesarlos
    var containers = document.querySelectorAll('.auto-sibling-swatches[data-sibling-inited]');
    containers.forEach(function (c) {
      if (c.children.length === 0) {
        c.removeAttribute('data-sibling-inited');
      }
    });

    var empty = document.querySelectorAll('.auto-sibling-swatches:not([data-sibling-inited])');
    if (empty.length > 0) {
      initializeSwatches();
    }
  }

  function startObserver() {
    var debounceTimer = null;
    var target = document.querySelector('.t4s-products, #t4s-container-main, .t4s-products-list') || document.body;

    observerInstance = new MutationObserver(function (mutations) {
      var relevant = false;
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            if ((node.classList && node.classList.contains('auto-sibling-swatches')) ||
                (node.classList && node.classList.contains('t4s-product')) ||
                (node.querySelector && node.querySelector('.auto-sibling-swatches'))) {
              relevant = true;
            }
          }
        });
        // Detectar si Varia reescribió el HTML (nodos removidos)
        m.removedNodes.forEach(function (node) {
          if (node.nodeType === 1 && node.querySelector &&
              node.querySelector('.auto-swatch-dot')) {
            relevant = true;
          }
        });
      });

      if (relevant) {
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () {
          retryInit();
        }, 300);
      }
    });

    observerInstance.observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleInit);
  } else {
    scheduleInit();
  }

})();

/* ══════════════════════════════════════════════════════════════════
   Swatches del filtro de color (módulo independiente).
   Sin swatch configurado en Search & Discovery, el tema deja la bolita
   sin fondo (--swatch--background indefinido) y se ve blanca/gris.
   Aquí se pinta desde un diccionario con TODOS los valores del catálogo
   (barrido jul 2026); compuestos ("BLANCO - NAVY") en franjas diagonales.
   Solo presentación: no toca recuentos, ni oculta filtros ni productos.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var MAPA = {
    marino:'#0e1f3d', navy:'#0e1f3d', azul:'#2196F3', blue:'#2196F3',
    celeste:'#a8def0', duck:'#00838f', terracota:'#d84315', 'terra cota':'#d84315',
    mustard:'#f9a825', mostaza:'#f9a825', negro:'#000000', black:'#000000',
    blanco:'#ffffff', white:'#ffffff', gris:'#757575', grey:'#757575',
    antracita:'#37474f', antracite:'#37474f', anthracite:'#37474f',
    rojo:'#c62828', red:'#c62828', rosa:'#ff80ab', pink:'#ff80ab',
    burdeos:'#800020', granate:'#800020', bordeaux:'#800020',
    marron:'#5d4037', 'marrón':'#5d4037', brown:'#5d4037',
    verde:'#2e7d32', green:'#2e7d32', verdegreen:'#2e7d32', oliva:'#556b2f',
    crema:'#f5f5dc', beige:'#f5f5dc', arena:'#e8d8c8', camel:'#c19a6b',
    kaki:'#8f9779', khaki:'#8f9779', caqui:'#8f9779',
    amarillo:'#f9a825', yellow:'#f9a825', naranja:'#ff6d00', orange:'#ff6d00',
    coral:'#ff7043', turquesa:'#00bcd4', lavanda:'#b39ddb', lila:'#ce93d8',
    taupe:'#8d6e63', kashmir:'#d4c5a9', 'azulón':'#1565c0', azulon:'#1565c0',
    sand:'#dcc9a3', 'baby blue':'#a8cbe8', denim:'#4a6a8a',
    indigo:'#3f51b5', 'indigo melange':'#5c6bc0', piedra:'#a8a29a',
    tostado:'#b07a4a', vainilla:'#f3e5c0', 'salmón':'#fa8072', salmon:'#fa8072',
    menta:'#98d8c8', mint:'#98d8c8', aqua:'#7fdbda', fresa:'#e91e63', teja:'#c65d3b',
    'blanco roto':'#f4efe6', 'off white':'#f8f4ec', ecru:'#f0e6d2',
    'light blue':'#a7c7e7', 'sky blue':'#87ceeb', 'medium blue':'#4169aa',
    'dark blue':'#1a3a6b', 'azul tinta':'#1f3a93', sax:'#4a90c2',
    'grey melange':'#9aa0a6', 'green melange':'#7a8c6f',
    'mottled grey':'#8f9496', 'motted grey':'#8f9496', 'gris claro':'#c9c9c9',
    petroleo:'#1f5f6b', 'petróleo':'#1f5f6b',
    'dark navy':'#0a1630', 'light navy':'#33507a', 'medieval navy':'#1b2a4a',
    'verde botella':'#1e5631', 'dark green':'#14532d', 'light green':'#a5d6a7',
    'verde agua':'#9fd8cb', 'amarillo pastel':'#f7e08c', 'amarillo suave':'#f7e8a0',
    'rose taupe':'#905d5d', vison:'#b7a08e', 'visón':'#b7a08e',
    'negro chocolate':'#2b1a12', 'dark blue denim':'#27415e',
    'denim blue':'#4a6a8a', 'black denim':'#23272b', jeans:'#5a7fa6',
    whisky:'#b5651d', marsala:'#964f4c', 'light brown':'#a97c50',
    'beige claro':'#efe3cd', cedro:'#886648', caldera:'#a0522d',
    malva:'#b784a7', 'dark khaki':'#6b6b47'
  };

  function fondoPara(label) {
    var c = label.toLowerCase().trim();
    if (c === 'multicolor') {
      return 'linear-gradient(135deg,#e53935 0% 25%,#fdd835 25% 50%,#43a047 50% 75%,#1e88e5 75% 100%)';
    }
    function busca(p) { return MAPA[p.trim()] || null; }
    var hexes = null;
    var directo = busca(c);
    if (directo) {
      hexes = [directo];
    } else {
      var partes = c.split(/\s*[-\/]\s*|\s+y\s+/).filter(Boolean);
      var mapeadas = partes.map(busca);
      if (mapeadas.length && mapeadas.every(Boolean)) {
        hexes = mapeadas;
      } else {
        var toks = c.split(/\s+/);
        if (toks.length > 1) {
          var m2 = toks.map(busca);
          if (m2.every(Boolean)) hexes = m2;
        }
      }
    }
    if (!hexes || !hexes.length) return null;
    if (hexes.length === 1) return hexes[0];
    var w = 100 / hexes.length, stops = [];
    hexes.forEach(function (hx, i) {
      stops.push(hx + ' ' + Math.round(i * w) + '% ' + Math.round((i + 1) * w) + '%');
    });
    return 'linear-gradient(135deg, ' + stops.join(', ') + ')';
  }

  function pintaSwatches() {
    document.querySelectorAll('.t4s-facet .t4s-filter_color > span').forEach(function (sw) {
      if (sw.style.getPropertyValue('--swatch--background')) return; // ya tiene
      var li = sw.closest('li');
      if (!li) return;
      var cnt = li.querySelector('.t4s-value-count');
      var label = li.textContent.replace(cnt ? cnt.textContent : '', '').replace(/\s+/g, ' ').trim();
      var bg = fondoPara(label);
      if (!bg) return; // desconocido: se deja como está
      sw.style.setProperty('--swatch--background', bg);
      if (/blanco|white|crema|vainilla|ecru|off white/.test(label.toLowerCase())) {
        sw.style.boxShadow = 'inset 0 0 0 1px rgba(0,0,0,.18)';
      }
    });
  }

  // Los facets llegan por AJAX tras cargar y se re-renderizan al filtrar:
  // repintar cuando aparezcan (idempotente y barato).
  var _t = null;
  function arranca() {
    pintaSwatches();
    new MutationObserver(function () {
      clearTimeout(_t);
      _t = setTimeout(pintaSwatches, 250);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca);
  } else {
    arranca();
  }
})();

/* ══════════════════════════════════════════════════════════════════
   Solo productos CON STOCK en colecciones (por defecto):
   - Sin filtros: se ocultan los productos agotados al completo.
   - Con filtro de talla activo: además se ocultan las tarjetas (clones
     por color incluidos) cuyo color no tiene ESA talla en stock.
   La casilla "Ver productos sin stock" (bloque Disponibilidad, bajo el
   filtro de Precio) muestra todo; la elección se recuerda en el
   navegador. Solo presentación: no toca datos, recuentos ni URLs.
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  if (!/^\/collections\//.test(location.pathname)) return;

  var KEY = 'wlt_ver_sin_stock';
  var css = document.createElement('style');
  css.textContent =
    'html.wlt-hide-soldout .t4s-products .t4s-product[data-product-options*=\'"available":false\']{display:none}' +
    'html.wlt-hide-soldout .t4s-products .t4s-product.wlt-sin-talla{display:none}' +
    '.wlt-vacio-msg{width:100%;padding:60px 20px;text-align:center;font-size:15px;}' +
    'html:not(.wlt-hide-soldout) .wlt-vacio-msg{display:none}';
  document.head.appendChild(css);

  function mostrar() { return localStorage.getItem(KEY) === '1'; }

  var SIZE_KEYS = ['talla', 'tallas', 'size', 'sizes'];

  function handleize(x) {
    return String(x).toLowerCase().trim()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function filtrosDeTalla() {
    var f = {}, any = false;
    new URLSearchParams(location.search).forEach(function (value, key) {
      var m = key.match(/^filter\.v\.option\.(.+)$/);
      if (m && value) {
        (f[handleize(m[1])] = f[handleize(m[1])] || []).push(value.toLowerCase().trim());
        any = true;
      }
    });
    return any ? f : null;
  }

  function opcionCasa(nombreOpcion, clave) {
    var h = handleize(nombreOpcion);
    if (h === clave) return true;
    return SIZE_KEYS.indexOf(h) !== -1 && SIZE_KEYS.indexOf(clave) !== -1;
  }

  function colorDeTarjeta(card) {
    var t = card.querySelector('.t4s-product-title');
    if (!t) return null;
    var partes = t.textContent.trim().split(/\s+[-–/]\s+/);
    return partes.length > 1 ? partes[partes.length - 1].toLowerCase().trim() : null;
  }

  function tieneStockFiltrado(card, filtros) {
    var el = card.querySelector('.auto-sibling-product-json');
    if (!el) return true; // sin datos: no ocultar
    var pr; try { pr = JSON.parse(el.textContent); } catch (e) { return true; }
    if (!pr || !pr.variants || !pr.options) return true;
    var color = colorDeTarjeta(card);
    var colorIdx = -1;
    for (var i = 0; i < pr.options.length; i++) {
      if (/color|colour/i.test(pr.options[i].name)) { colorIdx = i; break; }
    }
    return pr.variants.some(function (v) {
      if (!v.available) return false;
      if (colorIdx !== -1 && color &&
          String(v.options[colorIdx]).toLowerCase().trim() !== color) return false;
      return Object.keys(filtros).every(function (clave) {
        var idx = -1;
        for (var i = 0; i < pr.options.length; i++) {
          if (opcionCasa(pr.options[i].name, clave)) { idx = i; break; }
        }
        if (idx === -1) return true; // el filtro no aplica a este producto
        return filtros[clave].indexOf(String(v.options[idx]).toLowerCase().trim()) !== -1;
      });
    });
  }

  function marcar() {
    var filtros = filtrosDeTalla();
    document.querySelectorAll('.t4s-products .t4s-product').forEach(function (card) {
      var sin = !!(filtros && !tieneStockFiltrado(card, filtros));
      if (card.classList.contains('wlt-sin-talla') !== sin) {
        card.classList.toggle('wlt-sin-talla', sin);
      }
    });
    avisoVacio();
  }

  function avisoVacio() {
    var grid = document.querySelector('.t4s-products');
    if (!grid) return;
    var visibles = [...grid.querySelectorAll('.t4s-product')].filter(function (c) {
      return getComputedStyle(c).display !== 'none';
    }).length;
    var msg = grid.querySelector('.wlt-vacio-msg');
    if (visibles === 0 && document.documentElement.classList.contains('wlt-hide-soldout')) {
      if (!msg) {
        msg = document.createElement('div');
        msg.className = 'wlt-vacio-msg';
        msg.textContent = 'No quedan productos con stock aquí. Marca «Ver productos sin stock» en el filtro para mostrarlos.';
        grid.appendChild(msg);
      }
    } else if (msg) {
      msg.remove();
    }
  }

  function aplicar() {
    document.documentElement.classList.toggle('wlt-hide-soldout', !mostrar());
    avisoVacio();
  }

  function inyectarCasilla() {
    var price = document.querySelector('#t4s-filter-hidden .is--blockid_price');
    if (!price || document.getElementById('wlt-soldout-facet')) return;
    var div = document.createElement('div');
    div.id = 'wlt-soldout-facet';
    div.className = 't4s-col-item t4s-col-12 t4s-facet';
    div.style.order = '6'; // justo después de Precio (order 5)
    div.innerHTML =
      '<h5 class="t4s-facet-title">Disponibilidad</h5>' +
      '<div class="t4s-facet-content"><ul class="t4s-filter__values is--style-checkbox">' +
      '<li' + (mostrar() ? ' class="is--selected"' : '') + '><a href="#">' +
      '<div class="t4s-checkbox-wrapper t4s-pr t4s-oh"><svg focusable="false" viewBox="0 0 24 24" width="14" height="14" role="presentation"><path fill="currentColor" d="M9 20l-7-7 3-3 4 4L19 4l3 3z"></path></svg></div>' +
      'Ver productos sin stock</a></li></ul></div>';
    price.after(div);
    div.querySelector('a').addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation(); // que el tema no lo trate como un filtro AJAX
      localStorage.setItem(KEY, mostrar() ? '0' : '1');
      div.querySelector('li').classList.toggle('is--selected', mostrar());
      aplicar();
    });
  }

  // ── Recuentos coherentes con lo que se ve ──
  // Shopify cuenta productos que TIENEN el valor; si ocultamos los agotados,
  // el número debe ser el de productos CON STOCK en ese valor. Con la casilla
  // "ver sin stock" marcada se restaura el número original de Shopify.
  var _catalogo = null;
  function catalogo() {
    if (_catalogo) return Promise.resolve(_catalogo);
    var m = location.pathname.match(/\/collections\/([^\/]+)/);
    if (!m) return Promise.resolve(null);
    var todos = [];
    function pagina(n) {
      return fetch('/collections/' + m[1] + '/products.json?limit=250&page=' + n)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = d.products || [];
          todos = todos.concat(ps);
          if (ps.length === 250 && n < 4) return pagina(n + 1);
          _catalogo = todos;
          return todos;
        });
    }
    return pagina(1).catch(function () { return null; });
  }

  function recuentos() {
    var facets = document.querySelectorAll('#t4s-filter-hidden .t4s-facet');
    if (!facets.length) return;
    // con "ver sin stock" marcado: devolver los números originales de Shopify
    if (mostrar()) {
      document.querySelectorAll('#t4s-filter-hidden .t4s-value-count[data-wlt-orig]').forEach(function (sp) {
        sp.textContent = sp.getAttribute('data-wlt-orig');
        sp.closest('li').classList.remove('is--disabled');
      });
      return;
    }
    catalogo().then(function (productos) {
      if (!productos || !productos.length) return;
      facets.forEach(function (facet) {
        var link = facet.querySelector('a[href*="filter.v.option."]');
        if (!link) return;
        var pm = link.getAttribute('href').match(/filter\.v\.option\.([^=]+)=/);
        if (!pm) return;
        var clave = handleize(decodeURIComponent(pm[1]).replace(/\+/g, ' '));
        // productos de la colección que usan EXACTAMENTE esa opción
        var casan = [];
        productos.forEach(function (pr) {
          for (var i = 0; i < pr.options.length; i++) {
            if (handleize(pr.options[i].name) === clave) { casan.push({ p: pr, idx: i }); return; }
          }
        });
        if (!casan.length) return; // clave desconocida: no tocar
        facet.querySelectorAll('li').forEach(function (li) {
          var sp = li.querySelector('.t4s-value-count');
          if (!sp) return;
          if (!sp.hasAttribute('data-wlt-orig')) sp.setAttribute('data-wlt-orig', sp.textContent);
          var valor = li.textContent.replace(sp.textContent, '').replace(/\s+/g, ' ').trim();
          var n = 0;
          casan.forEach(function (c) {
            var hay = c.p.variants.some(function (v) {
              return v.available && String(v['option' + (c.idx + 1)] || '').trim() === valor;
            });
            if (hay) n++;
          });
          var txt = '(' + n + ')';
          if (sp.textContent !== txt) sp.textContent = txt;
          li.classList.toggle('is--disabled', n === 0 && !li.classList.contains('is--selected'));
        });
      });
    });
  }

  var _aplicarOrig = aplicar;
  aplicar = function () { _aplicarOrig(); recuentos(); };

  aplicar();
  marcar();
  inyectarCasilla();
  recuentos();
  // el grid y el cajón se re-renderizan por AJAX (filtros, clones de Gravity)
  var _t = null;
  new MutationObserver(function (muts) {
    var externo = muts.some(function (m) {
      return !(m.target && m.target.classList && m.target.classList.contains('wlt-vacio-msg')) &&
             !(m.target && m.target.classList && m.target.classList.contains('t4s-value-count'));
    });
    if (!externo) return;
    clearTimeout(_t);
    _t = setTimeout(function () { inyectarCasilla(); marcar(); recuentos(); }, 250);
  }).observe(document.body, { childList: true, subtree: true });
})();

/* ============================================================
   Recomendados del mini-carrito: barra-línea de scroll larga y
   arrastrable, en lugar de las dos flechas de flickity.
   El cajón se re-renderiza por AJAX, así que se engancha por
   MutationObserver sobre body y es idempotente (marca el nodo).
   ============================================================ */
(function () {
  'use strict';
  var SEL = '.t4s-minicart-recommendations_items.is--cards';

  function build(scroller) {
    if (scroller.dataset.wltSb) return;
    scroller.dataset.wltSb = '1';

    var bar = document.createElement('div');
    bar.className = 'wlt-rec-scroll';
    var thumb = document.createElement('span');
    thumb.className = 'wlt-rec-thumb';
    bar.appendChild(thumb);
    scroller.insertAdjacentElement('afterend', bar);

    function maxScroll() { return scroller.scrollWidth - scroller.clientWidth; }

    function update() {
      var ms = maxScroll();
      if (ms <= 1) { bar.classList.add('is--hidden'); return; }
      bar.classList.remove('is--hidden');
      var trackW = bar.clientWidth;
      var ratio = scroller.clientWidth / scroller.scrollWidth;
      var thumbW = Math.max(ratio * trackW, 24);
      var left = (scroller.scrollLeft / ms) * (trackW - thumbW);
      thumb.style.width = thumbW + 'px';
      thumb.style.left = left + 'px';
    }

    // arrastre / clic sobre la línea -> mueve el scroll
    var dragging = false;
    function toScroll(clientX) {
      var r = bar.getBoundingClientRect();
      var thumbW = thumb.offsetWidth;
      var x = clientX - r.left - thumbW / 2;
      var frac = x / (r.width - thumbW);
      frac = Math.min(1, Math.max(0, frac));
      scroller.scrollLeft = frac * maxScroll();
    }
    bar.addEventListener('pointerdown', function (e) {
      dragging = true;
      bar.setPointerCapture(e.pointerId);
      toScroll(e.clientX);
      e.preventDefault();
    });
    bar.addEventListener('pointermove', function (e) { if (dragging) toScroll(e.clientX); });
    bar.addEventListener('pointerup', function () { dragging = false; });
    bar.addEventListener('pointercancel', function () { dragging = false; });

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (window.ResizeObserver) new ResizeObserver(update).observe(scroller);
    // las imágenes cargan tarde y cambian scrollWidth
    setTimeout(update, 60);
    setTimeout(update, 400);
    setTimeout(update, 1200);
    update();
  }

  function scan() {
    document.querySelectorAll(SEL).forEach(build);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);

  new MutationObserver(function () { scan(); })
    .observe(document.body, { childList: true, subtree: true });
})();

/* ============================================================
   Ficha de producto: no arrancar en una talla sin stock.
   Al entrar con ?variant=... el tema puede fijar una combinacion
   agotada (p. ej. 50/BLANCO) y la ficha aparece con "AGOTADO",
   como si no quedara nada, aunque haya muchas tallas. Aqui se
   salta a la primera talla CON STOCK del color activo.
   OJO: el tema reaplica la variante de la URL DESPUES de cargar,
   asi que hay que vigilar unos segundos y volver a corregir si
   revierte (por eso no se para al primer intento).
   ============================================================ */
(function () {
  'use strict';
  if (!/^\/products\//.test(location.pathname)) return;

  function norm(t) { return (t || '').replace(/\s+/g, ' ').trim().toUpperCase(); }

  function corrige(prod) {
    var items = document.querySelectorAll('.t4s-swatch__item');
    if (!items.length) return;
    var colores = [], tallas = [];
    Array.prototype.forEach.call(items, function (el) {
      (el.classList.contains('is-sw__color') ? colores : tallas).push(el);
    });
    if (!tallas.length) return;

    var colSel = colores.filter(function (e) { return e.classList.contains('is--selected'); })[0];
    var tallaSel = tallas.filter(function (e) { return e.classList.contains('is--selected'); })[0];
    if (!tallaSel) return;

    var color = colSel ? norm(colSel.textContent) : null;
    var talla = norm(tallaSel.textContent);

    var iT = -1, iC = -1;
    prod.options.forEach(function (o, i) {
      var n = (typeof o === 'string' ? o : o.name).toLowerCase();
      if (/talla|size/.test(n)) iT = i; else if (/color|colour/.test(n)) iC = i;
    });
    if (iT < 0) return;

    function hay(t) {
      return prod.variants.some(function (v) {
        return v.available && norm(v.options[iT]) === norm(t) &&
               (iC < 0 || !color || norm(v.options[iC]) === color);
      });
    }
    if (hay(talla)) return;                    // ya esta en una talla con stock

    for (var i = 0; i < tallas.length; i++) {
      if (hay(norm(tallas[i].textContent))) { tallas[i].click(); return; }
    }
  }

  function arranca() {
    var h = (location.pathname.split('/products/')[1] || '').split(/[?#]/)[0];
    if (!h) return;
    fetch('/products/' + h + '.js').then(function (r) { return r.json(); }).then(function (prod) {
      var n = 0;
      // se vigila ~9s: si el tema revierte a una talla agotada, se vuelve a corregir
      var t = setInterval(function () { corrige(prod); if (++n > 30) clearInterval(t); }, 300);
      corrige(prod);
    }).catch(function () {});
  }

  if (document.readyState !== 'loading') arranca();
  else document.addEventListener('DOMContentLoaded', arranca);
})();
